define([
    'system/domain/entity/tag-category',
    'backbone'
], function(
    TagCategory,
    Backbone
    ){
    return Backbone.Collection.extend({
        model: TagCategory,

        initialize: function() {
            this.on('change', function(category) {
                if(category.get('deleted')) {
                    category.trigger('remove');
                }
            });
        },

        comparator: function(category) {
            return category.get('name');
        }
    });
});



// WEBPACK FOOTER //
// ./system/domain/collection/tag-category.js